"use client";
import React from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import SecurityServicesTabs from "@/components/pageTabs/securityServicesTabs";
import TechStack from "./components/techStack";
import WhyOneMindComponent from "./components/whyOnemind";
import FeaturesComp from "./components/features";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import AdvantageComp from "./components/advantages";

const RansomwareProtectionPage = () => {
  return (
    <Box>
      <Hero />
      <PageLayout>
        <SecurityServicesTabs />
        <Intro />
        <AdvantageComp />
        <TechStack />
        <WhyOneMindComponent />
      </PageLayout>
      <FeaturesComp />
      <PageLayout showContactForm>
        <Faqs />
      </PageLayout>
    </Box>
  );
};

export default RansomwareProtectionPage;
